// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* To override the PrimeReact Confirm-Dialog colour stylings. */\n.ontario-button--primary {\n    background-color: #06c !important;\n    color: #fff !important;\n}\n\n.ontario-button--secondary {\n    background-color: #fff !important;\n    color: #06c !important;\n}\n\n.ontario-button--tertiary {\n    background-color: transparent !important;\n    color: #06c !important;\n}\n\n.dialog-style {\n    max-width: 600px;\n}", ""]);
// Exports
module.exports = exports;
